import { render } from "./send-as.vue?vue&type=template&id=d9929d5c&lang=pug"
import script from "./send-as.vue?vue&type=script&setup=true&lang=js"
export * from "./send-as.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__